<template>
  <dx-popup
    :visible.sync="isVisible"
    :drag-enabled="false"
    :close-on-outside-click="true"
    :show-title="true"
    :title="$t('Add containers')"
  >
    <dx-scroll-view>
      <b-row class="mb-5">
        <b-col>
          <dx-form-group
            :label="$t('containers')"
            :margin-bottom="false"
          >
            <dx-text-area
              v-model="containers"
              value-change-event="input"
              height="120"
              styling-mode="filled"
              :max-length="1000"
            />
          </dx-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="10">
          <ul>
            <li
              v-for="item in getContainers()"
              :key="item.number"
            >
              {{ item.number }} <span
                v-if="!item.valid"
                style="color:red"
              >{{ $t("container number not valid") }}</span>
            </li>
            <li v-if="isLimitExceeded()" style="color:red">
              Превышено кол-во контейнеров указанное в поручении. Возможно добавить не более: {{ calcContainersLimit() }}
            </li>
          </ul>
        </b-col>
      </b-row>
      <b-row class="ml-0 mr-1 mt-auto">
        <dx-button
          :disabled="!isAllContainersValid()"
          :text="$t('Add')"
          type="success"
          styling-mode="contained"
          class="custom-btn mr-2 ml-auto"
          @click="submit"
        />
        <dx-button
          :text="$t('Cancel')"
          type="success"
          styling-mode="text"
          class="custom-btn"
          @click="isVisible = false"
        />
      </b-row>
    </dx-scroll-view>
  </dx-popup>
</template>

<script>
import { mapState } from 'vuex';

import { DxButton, DxTextArea } from 'devextreme-vue';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';

import containerNumberValidator from '@/utils/container-number-validator';
import DxFormGroup from '@/components/common/DxFormGroup.vue';


export default {
  name: 'AddContainerModal',
  components: {
    DxButton,
    DxPopup,
    DxScrollView,
    DxTextArea,
    DxFormGroup,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    leftContainers: Number,
  },
  data: () => ({
    containers: '',
  }),
  computed: {
    ...mapState(['user']),
    isVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  created() {
  },
  methods: {
    submit() {
      this.$emit('submit', this.getContainers());
      this.isVisible = false;
    },
    normalize_space(value) {
      // Replace repeated spaces, newlines and tabs with a single space
      return value.replace(/^\s*|\s(?=\s)|\s*$/g, '');
    },
    getContainers() {
      let s = this.containers || '';
      s = s.replace(/\r/g, ' ');
      s = s.replace(/\n/g, ' ');
      s = s.replace(/,/g, ' ');
      const results = [];
      const uniq = [...new Set(this.normalize_space(s)
        .split(' '))];
      uniq.forEach(i => {
        results.push(
          {
            number: i,
            valid: containerNumberValidator(i),
          },
        );
      });
      return results;
    },
    calcContainersLimit() {
      return this.leftContainers;
    },
    isLimitExceeded() {
      return this.getContainers().length > this.calcContainersLimit();
    },
    isAllContainersValid() {
      let result = true;
      this.getContainers()
        .forEach((i) => {
          result = result && i.valid;
        });
      return result && !this.isLimitExceeded();
    },

  },
};
</script>
